import { Box, Grid } from "@mui/material";
import React from "react"
import { Profile } from "../../../services/profileService";
import { useMyProfileQuery } from "../../../services/profileService/profile-api";
import { Loading } from "../../shared";
import {ProfileHeader, CenterAccess, ClaimsAccess, VobAssignments} from '../features'
import { LookupUser } from "../features/lookupUser/LookupUser";

function MyProfile(){
    const {data, isLoading} = useMyProfileQuery();
    const profile = data ?? new Profile();
    
    return <React.Fragment>
        {isLoading === true ?
        <Loading/> :
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <ProfileHeader profile={profile}/>
            <Grid container spacing={2} sx={{ mt: 1, flex: 1 }}>
                <Grid item xs={12} md={6}>
                    <CenterAccess profile={profile}/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ClaimsAccess profile={profile}/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <VobAssignments profile={profile}/>
                </Grid>
            </Grid>
        </Box>
        }
        <LookupUser/>
    </React.Fragment>
}

export {MyProfile}